import ReactSwitch, { ReactSwitchProps } from "react-switch";
import styled from "styled-components";

export const Switch = styled(ReactSwitch)<ReactSwitchProps>``;

Switch.defaultProps = {
  offColor: "#FF7285",
  onColor: "#4AD991"
};